'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Cog = require('./Cog');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Cog).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Cog/index.js
// module id = 1157
// module chunks = 1